import { createLogger, transports, format } from 'winston';
import 'setimmediate';
import DailyRotateFile from 'winston-daily-rotate-file';
import BrowserConsole from './_loggerBrowserConsole';
import { LOG_LEVEL, NODE_ENV } from '../_constant';
import {
	LOG_TO_DISK,
	NEXT_PUBLIC_LOG_TO_CONSOLE,
	LOG_FILE_FOLDER,
	SEQ_LOG,
	SEQ_URL,
	SEQ_ROLE,
	SEQ_SYSTEM,
} from '_constant';
import { SeqTransport } from '@datalust/winston-seq';

const serverside = typeof window === 'undefined';
const development = NODE_ENV === 'development';

const logger = createLogger({
	exitOnError: false,
	level: LOG_LEVEL,
	format: format.combine(
		format.errors({ stack: true }),
		format.splat(),
		format.json(),
		format.timestamp({
			format: 'DD-MM-YYYY HH:mm:ss',
		}),
	),
	defaultMeta: {
		role: SEQ_ROLE,
		system: SEQ_SYSTEM,
	},
	transports: [
		new transports.Console({
			handleExceptions: true,
			silent: true,
		}),
	],
});

// Write logs to console & browser console,
// when NEXT_PUBLIC_LOG_TO_CONSOLE is enabled
let browserConsoleTransport: BrowserConsole;
if (NEXT_PUBLIC_LOG_TO_CONSOLE) {
	browserConsoleTransport = new BrowserConsole({
		handleExceptions: true,
		silent: false,
		format: format.simple(),
	});

	logger.add(browserConsoleTransport);
}

// Write log to disk,
// when LOG_TO_DISK is enabled & we're on the server
let dailyRotateTransport: DailyRotateFile;
if (LOG_TO_DISK && serverside) {
	// Send logs to a file daily
	dailyRotateTransport = new DailyRotateFile({
		handleExceptions: true,
		silent: false,
		filename: LOG_FILE_FOLDER,
		datePattern: 'YYYY-MM-DD-HH',
		zippedArchive: true,
		maxSize: '20m',
		maxFiles: '14d',
	});

	logger.add(dailyRotateTransport);
}

// sending logs to Seq
let seqTransport: SeqTransport;
if (SEQ_LOG) {
	seqTransport = new SeqTransport({
		serverUrl: SEQ_URL,
		onError: (e) => {
			// eslint-disable-next-line no-console
			console.error(e);
		},
		handleExceptions: true,
		handleRejections: false,
	});

	logger.add(seqTransport);
}

if (development) {
	logger.info('LOGGER is in DEVELOPMENT MODE');
}

export default logger;
